import styled from 'styled-components';
import { LinearProgress } from '@material-ui/core';

interface StyledLinearProgressProps {
  $loading: boolean;
  $bottom?: boolean;
}

export const StyledLinearProgress = styled(LinearProgress)<StyledLinearProgressProps>`
  visibility: ${(props) => (props.$loading ? 'visible' : 'hidden')};
  ${(props) => (props.$bottom ? 'margin-top' : 'margin-bottom')}: 10px;
`;
